import {IEnvironment} from "./i-environment";

export const environment: IEnvironment = {
  production: false,
  api: {
    authentication: {
      useSSL: true,
      url: "api.qas.zaeper.com/auth"
    },
    application: {
      useSSL: true,
      url: "api.qas.zaeper.com/developer-application"
    },
    user: {
      useSSL: true,
      url: "api.qas.zaeper.com/developer-user"
    },
    billing: {
      useSSL: true,
      url: "api.qas.zaeper.com/developer-billing"
    },
    registry: {
      useSSL: true,
      url: "api.qas.zaeper.com/registry"
    }
  },
  sites: {
    authentication: {
      useSSL: true,
      url: "auth.qas.zaeper.com"
    },
    userDashboard: {
      useSSL: true,
      url: "dashboard.qas.zaeper.com"
    },
    vendorDashboard: {
      useSSL: true,
      url: "vendor.qas.zaeper.com"
    },
    businessPortalDashboard: {
      useSSL: true,
      url: "business-portal.qas.zaeper.com"
    }
  }
};
